import styled from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.section`
    width: inherit;
    overflow: hidden;
    padding: 0 0 0.5rem;
    position: relative;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 1.5rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 1.5rem 4rem 1rem;
    }
`

export const NavButton = styled.div<{ disabled?: boolean }>`
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
    background-color: ${props => props.theme.colors.white};
    border-radius: 100%;
    height: 3rem;
    width: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0.5rem 0.625rem 0.0625rem #21212123, 0 0.1875rem 0.875rem 0.1875rem #2121210f,
        0 0.25rem 0.625rem 0 #21212119;
    opacity: ${props => (props.disabled ? 0.5 : 1)};
    transition: opacity 200ms ease-in;

    &:hover {
        opacity: ${props => (props.disabled ? 0.5 : 0.8)};
    }

    @media only screen and (max-width: ${tabletBreakpoint.max}px) {
        display: none;
    }
`

export const SliderContainer = styled.div`
    position: ${props => props.theme.style.position.relative};
    max-width: fit-content;
    margin-top: 1rem;
`
